import { useCallback } from "react";
import axios from "axios";
import projectUtils from "../../../../../utils/project-utils.js";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

let isCancel = false
export function useAnalysis() {

    const runAnalysis = useCallback(async (formData) => {
        isCancel = false;

        const { data: jobId } = await axios.post(`${API_KEEPER}/analysis/associationNetwork/exec`, formData);

        while (true) {
            if (isCancel) {
                await axios.post(`${API_KEEPER}/analysis/cancel/${jobId}`)
                return null;
            }

            const { data: statusResp } = await axios.get(`${API_KEEPER}/analysis/status/${jobId}`);

            if (statusResp === "FINISHED") {
                const { data: resultData } = await axios.get(`${API_KEEPER}/analysis/result/${jobId}`);
                return resultData;
            }

            if (statusResp === "ERROR") {
                projectUtils.swalErrorMessage("", "Erro ao iniciar análise.", "Ok");
                return null;
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));
        }
    }, []);

    const cancel = useCallback(() => {
        isCancel = true;
    }, []);

    return { runAnalysis, cancel };
}
